<div class="filter-container" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <edt-filter-header [countActiveFilters]="activeFilter.size-1" filterName="Fecha inicio"  (openFilter)="toogleOpen($event)"></edt-filter-header>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  cdkConnectedOverlayWidth="300"
  (overlayOutsideClick)="close($event)"
>
  <div class="row align-items-start filter-menu">
    <div class="col-12 my-2">Filtrar por rango</div>
    <div class="col-12 my-2">
      <mat-chip-listbox
        aria-label="Filtrar por fecha"
        (change)="statusChanged($event)"
      >
      <mat-chip-option value="0" [selected]="toogleSelected('0')" color="accent"
          >Hoy</mat-chip-option
        >

        <mat-chip-option value="1" color="accent" [selected]="toogleSelected('1')"
          >Semana</mat-chip-option
        >

        <mat-chip-option value="2" color="accent" [selected]="toogleSelected('2')"
          >Mes</mat-chip-option
        >

        <mat-chip-option value="3" color="accent" [selected]="toogleSelected('3')"
          >Personalizado</mat-chip-option
        >

      </mat-chip-listbox>
    </div>
    <div class="col-12 my-2">
      <mat-form-field>
        <mat-label>Indique un rango</mat-label>
        <mat-date-range-input
          [rangePicker]="picker"
          [max]="maxDate"
          (click)="picker.open()"
        >
          <input
            matStartDate
            placeholder="Inicio"
            [value]="startDate"
            (dateChange)="startChanged($event)"
          />
          <input
            matEndDate
            placeholder="Fin"
            [value]="endDate"
            (dateChange)="endChanged($event)"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <div class="col-12 my-2 text-end">
      <button class="me-2" mat-stroked-button color="accent" (click)="cancel()">
        Cancelar
      </button>
      <button
        mat-flat-button
        color="accent"
        [disabled]="!selectedStatus && (!startDate || !endDate)"
        (click)="applyFilter()"
      >
        Aplicar
      </button>
    </div>
  </div>
</ng-template>
